import {Component} from '@angular/core';

@Component({
    selector: 'detail-header',
    imports: [],
    template: '<div class="detail-header-container"><ng-content/></div>',
    standalone: true,
    styles: [`
    .detail-header-container {
      display: flex;
      gap: 12px;
      align-items: center;
    }
  `]
})
export class DetailHeaderComponent {

}
